module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('AdminTools'), _vm._v(" "), _c('div', {
    staticClass: "flexContainer full what"
  }, [_c('section', {
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('section', {
    staticClass: "brand-list"
  }, [_c('section', {
    staticClass: "searchResultsWrapper"
  }, [_c('h1', {
    staticClass: "headline uppercase"
  }, [_vm._v("Single Sign On Systems")]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('a', {
    staticClass: "btnExp iBlock pointer txtCenter active fright",
    attrs: {
      "tag": "span"
    },
    on: {
      "click": function($event) {
        _vm.openModal(null);
      }
    }
  }, [_vm._v("\n                                    Add a SSO system\n                                ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "full mt10 separator"
  }), _vm._v(" "), _vm._l((_vm.SsoSystems), function(sso) {
    return _c('div', {
      key: sso.id,
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs"
    }, [_c('div', {
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs list"
    }, [_c('div', {
      staticClass: "listDisplay full ai-c jc-sb flexContainer"
    }, [_c('div', {
      staticClass: "flexContainer fd-c size1of6"
    }, [_c('span', {
      staticClass: "listTitle uppercase center"
    }, [_vm._v(_vm._s(sso.name))])]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of6"
    }, _vm._l((sso.domains), function(domain) {
      return _c('ul', {
        key: domain.name,
        staticClass: "domains"
      }, [_c('li', [_vm._v("@" + _vm._s(domain.name))])])
    })), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of6"
    }, [_c('span', {
      staticClass: "center"
    }, [_vm._v("Nbr of users: " + _vm._s(sso.numberOfUsers))])]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of6 content-button"
    }, [_c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.openModal(sso);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil-alt"
    })]), _vm._v(" "), _c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.deleteSso(sso);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])])])])])
  })], 2)])]), _vm._v(" "), (_vm.isModalOpen) ? _c('SsoSystemFormModal', {
    attrs: {
      "existingSsoSystem": _vm.SsoSystemInModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.onModalClose($event);
      }
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58df49c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/sso-system/SsoSystemList.vue
// module id = 3203
// module chunks = 0